var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6830_82057)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6830_82057)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4062 6.39038H27.1733V22.1574H22.7051V20.8574H25.8733V7.69038H12.7063V10.4532H11.4062V6.39038ZM20.5516 12.5329H7.28437V26.2869H20.5516V12.5329ZM5.98438 11.2329V27.5869H21.8516V11.2329H5.98438ZM18.4665 17.113C18.7203 16.8592 18.7203 16.4476 18.4665 16.1938C18.2126 15.94 17.8011 15.94 17.5472 16.1938L12.4934 21.2477L10.8045 19.5617C10.5505 19.3081 10.1389 19.3085 9.8853 19.5625C9.63168 19.8166 9.63203 20.2281 9.88609 20.4817L12.4941 23.0854L18.4665 17.113Z",
    fill: "#6621F1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6830_82057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.601562 0.955078)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6830_82057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.601562 0.955078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAll);
export default __webpack_public_path__ + "static/media/select-all.80f524f32de1c068e4aeba1739d4476d.svg";
export { ForwardRef as ReactComponent };